import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";

class Popup extends React.Component<{
    onClose?: () => void;
    big?: boolean;
    showClose?: boolean;
}> {
    public render(): React.ReactElement {
        const { onClose, big, showClose = true } = this.props;
        return (
            <>
                <div className="popup-grayback" onClick={onClose} />
                <div className={`${big ? "popup-bigbox" : "popup-box"}`} data-at_id={`${big ? "big_popup" : "popup"}`}>
                    {showClose ? (
                        <span className="popup-close" onClick={onClose} data-at_id="popup_close_button">
                            <CloseIcon />
                        </span>
                    ) : null}
                    {this.props.children}
                </div>
            </>
        );
    }
}

export { Popup };
